<template>
    <div>
        <div class="xinz">
            <div class="right">
                <el-button type="warning" @click="addCustGroup" v-if="custGroupAdd"><i class="fa fa-plus" /> {{$t('m.t_newcustomergroup')}}</el-button>
            </div>
        </div>
        <div>
            <el-form :inline="true"  class="demo-form-inline" @keyup.native.enter="getCustGroupPageList" size="small">
                <el-form-item :label="$t('m.t_search')">
                    <el-input :placeholder="$t('m.t_groupname')"  v-model="serchGroupName" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-input :placeholder="$t('m.t_custcode')"  v-model="serchCustNo" clearable>
                    </el-input>
                </el-form-item>
               <!-- <el-form-item >
                    <el-autocomplete
                            v-model="serchCustNo"
                            :fetch-suggestions="querySearch"
                            :placeholder="$t('m.t_custcode')"
                            :trigger-on-focus="false"
                            autocomplete="off"
                    ></el-autocomplete>
                </el-form-item>-->
                <el-form-item>
                    <el-button type="primary" @click="getCustGroupPageList()"><i class="fa fa-search" /> {{$t('m.b_query')}}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                    v-loading="tableloading"
                    @selection-change="handleSelectionChange"
                    :data="custGroupList"
                    :empty-text="$t('m.t_nodata')"
                    stripe
                    border
                    class="dataListTable">

                <el-table-column
                        prop="groupName"
                        align="left"
                        :label="$t('m.t_groupname')">
                </el-table-column>
                <!--<el-table-column
                        prop="description"
                        align="left"
                        label="Description">
                </el-table-column>-->

                <el-table-column
                        prop="id"
                        align="center"
                        width="100"
                        :label="$t('m.b_opt')">
                    <template slot-scope="scope">
                        <template>
                            <el-dropdown>
                                <el-button size="small" type="primary">
                                    <i class="fa fa-mouse-pointer"/> {{$t('m.b_opt')}}
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item size="small" type="primary" @click.native="custGroupEdit(scope.$index, scope.row)" v-if="custGroupNameEdit" ><i class="fa fa-edit"/>{{$t('m.t_updatecustomergroup')}}</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="deleteCustEdit(scope.$index, scope.row)" v-if="custGroupDelete"><i class="fa fa-trash"/> {{$t('m.t_deletecustomergroup')}}</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="itemEdit(scope.$index, scope.row)" v-if="custGroupInfromation"><i class="fa fa-eye"/> {{$t('m.t_customergroupsee')}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                    layout="total, prev, pager, next"
                    @current-change="custGroupPageChange"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
        </div>


        <!-- 客戶組名編輯页面 -->
        <el-dialog :title="dialogAddName" :visible.sync="dialogDiscAddVisible" width="450px" :close-on-click-modal=false>
            <el-form  :model="custGroupForm"  :rules="custGroupRules" ref="custGroupForm" label-width="130px">
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_customergroupname')+'：'" prop="groupName" >
                            <el-input v-model="custGroupForm.groupName"  auto-complete="off" style="width:180px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDiscAddVisible = false">{{$t('m.b_cancel')}}</el-button>
                <el-button type="primary"  @click="custGroupSave" :loading="Addloading">{{$t('m.b_save')}}</el-button>
            </div>
        </el-dialog>

        <!-- 客戶成员新增页面 -->
        <el-dialog :title="dialogEditName" :visible.sync="dialogDiscEditVisible" width="450px">
            <el-form  :model="custForm"  :rules="custRules" ref="custForm" label-width="130px">
                <el-row :gutter="0">
                    <el-col :span="24">
                      <!--  <el-form-item label="客戶名：" prop="custNo" >
                            <el-input v-model="custForm.custNo" placeholder="客戶名" auto-complete="off" style="width:180px"></el-input>
                        </el-form-item>-->
                        <el-form-item :label="$t('m.t_customer')+'：'" prop="custNo">
                            <el-select v-model="custForm.custNo" default-first-option  placeholder="" filterable  remote  :remote-method="itemRemoteMethod"  style="width:200px">
                                <el-option
                                        v-for="item in custOptions"
                                        :key="item.id"
                                        :label="item.code"
                                        :value="item.id">
                                    <span style="float: left">{{ item.code }}</span>&nbsp;
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDiscEditVisible = false">{{$t('m.b_cancel')}}</el-button>
                <el-button type="primary"  @click="custMgtSave" :loading="Addloading">{{$t('m.b_save')}}</el-button>
            </div>
        </el-dialog>

        <!-- 子列表页面-->
        <el-dialog :title="dialogName" :visible.sync="dialogItemVisible" width="80%">
            <div>
                <div style="float:right">
                    <el-button type="warning" @click="AddCustEdit" v-if="custGroupAdd"><i class="fa fa-plus" /> {{$t('m.b_newmembergrp')}}</el-button>
                    <div style="height: 10px"></div>
                </div>
                <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                        v-loading="tableloading"
                        @selection-change="handleSelectionChange"
                        :data="custGroupItemList"
                        stripe
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="groupName"
                            align="left"
                            :label="$t('m.t_groupname')">
                    </el-table-column>
                    <el-table-column
                            prop="custNo"
                            align="left"
                            width="110"
                            :label="$t('m.t_custcode')">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            align="left"
                            :label="$t('m.t_memebername')">
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            align="center"
                            width="110"
                            :label="$t('m.b_opt')">
                            <template slot-scope="scope">
                                <el-button size="small" type="primary" @click="deleteCustGroupId(scope.$index, scope.row)" v-if="custGroupNameEdit"><i class="fa fa-edit"/> {{$t('m.b_breakrelation')}}</el-button>
                            </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        layout="total, prev, pager, next"
                        @current-change="handleItemChange"
                        :current-page.sync="groupPager.page"
                        :page-size="groupPager.size"
                        :total="groupPager.total">
                </el-pagination>
            </div>
            <div style="height: 50px">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogItemVisible = false">{{$t('m.b_cancel')}}</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import { getCustGroupMgtList,getGroupByCatCode,insertCustGroup,updateCustGroup,getCustGroupMgtById,getCustGroupMgtDetailsList,queryAllCustByCode,getCustAllCustMgtList,updateCustNoGroupId,deleteGroupName,updateCustGroupIds} from '../api/api'

    export default {
        data() {

            return {
                //查詢條件
                serchGroupName:"",
                serchCustNo:"",
                selectionItems:[],
                custGroupItemList:[],
                tableloading:false,
                dialogDiscAddVisible:false,
                dialogDiscEditVisible:false,
                Addloading:false,
                Editloading:false,
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                custOptions:[],
                dialogItemVisible:false,
                dialogName:'',
                custGroupList:[],
                dialogEditName:"",
                dialogAddName:"",
                groupPager:{
                    page:0,
                    size:10,
                    total:0
                },
                custGroupForm:{
                    id:"",
                    groupName:""
                },
                custForm:{
                    custId:"",
                    custNo:"",
                    groupId:"",
                },
                custGroupRules:{
                    groupName:[
                        {required: true, message: this.$t('m.m_groupnameinput'), trigger: 'blur' },
                    ]
                },custRules:{
                    custNo:[
                        {required: true, message: this.$t('m.m_nocustomer'), trigger: 'blur' },
                    ]
                }
            }
        },
        methods: {
            querySearch(queryString, cb){
                if (queryString!=""){
                    var params={custNo:queryString,groupId:this.id};
                    getCustAllCustMgtList(params).then(data=>{
                        let {data:res={}}=data;
                        this.custOptions=res.data==null?[]:res.data;
                        for(let i of this.custOptions){
                            i.value = i.custNo;
                        };
                        let custOptions = this.custOptions;
                        var results = queryString?custOptions.filter(this.createFilter(queryString)): searchItemOptions;
                        cb(results);
                    });
                }
            },
            createFilter(queryString) {
                return (custOptions) => {
                    return (custOptions.custNo.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
                };
            },
            custGroupPageChange(val){
                this.getCustGroupPageList();
            },handleItemChange(val){
                this.serchCustDetails()
            },
            handleSelectionChange(val){
               this.selectionItems=val;
            },addCustGroup(){
                this.custGroupForm={
                    id:"",
                    groupName:""
                },
                this.dialogAddName=this.$t('m.t_newcustomergroup')
                this.dialogDiscAddVisible=true;
                this.resetForm("custGroupForm");
                this.custOptions=[];
            },itemRemoteMethod(query){
                if (query!=""){
                    var params={custNo:query,groupId:null};
                    getCustAllCustMgtList(params).then(data=>{
                        let {data:res={}}=data;
                        this.custOptions=res.data;
                    });
                }
            },deleteCustGroupId(index,row){
                this.$confirm(this.$t('m.m_deleteconfirm'), this.$t('m.m_info'), {
                    confirmButtonText: this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.b_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.custForm.custId=row.id;
                    this.custForm.custNo=row.id;
                    var params = Object.assign({}, this.custForm);
                    updateCustGroupIds(params).then(data=>{
                        let {errcode,errmsg}=data.data;
                        if(errcode==200){
                            this.$message.success(this.$t('m.m_removesuc'));
                            this.resetForm("custForm");
                            this.custOptions=[];
                            this.serchCustDetails();
                        }else{
                            this.$message.error(data.errmsg);
                        }
                    });
                })/*.catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('m.b_canceledDeleting')
                    });
                });*/
            },
            deleteCustEdit(index,row){
                this.$confirm(this.$t('m.m_deleteconfirm'), this.$t('m.m_info'), {
                    confirmButtonText: this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.t_cancel'),
                    type: 'warning'
                }).then(() => {
                    var params = Object.assign({}, this.custForm);
                    params.id=row.id;
                    deleteGroupName(params).then(data=>{
                        let {errcode,errmsg}=data.data;
                        if(errcode==200){
                            this.$message.success(this.$t('m.m_deletesuc'));
                            this.getCustGroupPageList();
                        }else{
                            this.$message.error(data.errmsg);
                        }
                    });
                })
            },
            custGroupEdit(index,row){
                this.dialogAddName=this.$t('m.t_updatecustomergroup'),
                this.dialogDiscAddVisible = true;
                this.resetForm("custGroupForm");
                this.custGById(row.id);
            },getCustGroupPageList(){
                this.tableloading=true;
                var params={page:this.pager.page,size:this.pager.size,groupName:this.serchGroupName.trim(),custNo:this.serchCustNo.trim()};

                return getCustGroupMgtList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.custGroupList=items;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },custGById(id){
                return getCustGroupMgtById(id).then(data=>{
                    let {data:res={}}=data;
                    let item=res.data;
                    Object.assign(this.custGroupForm,item);
                });
            },itemEdit(index,row){
                this.dialogName=row.groupName+" - "+this.$t('m.t_memberdata');
                this.dialogItemVisible=true;
                this.id=row.id;
                this.custForm.groupId=row.id;
                this.serchCustDetails();
            },AddCustEdit(){
                this.dialogEditName=this.$t('m.b_newmembergrp');
                this.dialogDiscEditVisible=true;
                this.resetForm("custForm");
            },
            serchCustDetails(){
                this.tableloading=true;

                var params={page:this.groupPager.page,size:this.groupPager.size,id:this.id};
                return getCustGroupMgtDetailsList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.custGroupItemList=items;
                        this.groupPager.total=total;
                        this.groupPager.page=page;
                        this.groupPager.size=size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            custMgtSave(){//新增客戶組成員
                this.$refs.custForm.validate((valid) => {
                        if (valid) {
                            this.custForm.custId=this.custForm.custNo;
                            var params = Object.assign({}, this.custForm);

                            updateCustNoGroupId(params).then(data => {
                                this.Addloading = false;
                                let {errcode, errmsg} = data.data;
                                if (errcode == 200) {
                                    this.$message.success(this.$t('m.m_newmembersuc'));
                                    this.custOptions=[];
                                    this.resetForm("custForm");
                                    this.serchCustDetails();
                                    this.dialogDiscEditVisible = false;
                                } else {
                                    this.$message.error(errmsg);
                                }
                            }, err => {
                                this.Addloading = false;
                            });
                        }
                });
            },
            custGroupSave(){
                this.$refs.custGroupForm.validate((valid) => {
                        if (valid) {
                            if(this.custGroupForm.id=="") {
                                //var params = {groupName: this.custGroupForm.groupName}

                                var params = Object.assign({},this.custGroupForm);
                                insertCustGroup(params).then(data => {
                                    this.Addloading = false;
                                    let {errcode,errmsg}=data.data;
                                    if (errcode == 200) {
                                        this.$message.success(this.$t('m.m_newsucs'));
                                        this.getCustGroupPageList();
                                        this.resetForm("custGroupForm");
                                        this.dialogDiscAddVisible = false;
                                    } else {
                                        this.$message.error(errmsg);
                                    }
                                }, err => {
                                    this.Addloading = false;
                                });
                            }else{
                                var params = Object.assign({},this.custGroupForm);
                                updateCustGroup(params).then(data => {
                                    this.Addloading = false;
                                    let {errcode,errmsg}=data.data;
                                    if (errcode == 200) {
                                        this.$message.success(this.$t('m.m_updatesucs'));
                                        this.getCustGroupPageList();
                                        this.resetForm("custGroupForm");
                                        this.dialogDiscAddVisible = false;
                                    } else {
                                        this.$message.error(errmsg);
                                    }
                                }, err => {
                                    this.Addloading = false;
                                });
                            }
                        }
                });
            },
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },
        mounted() {
            this.getCustGroupPageList();
        },
        computed: {
            custGroupAdd(){
                return this.$store.getters.hasPermission("CUST_GROUP_ADD");
            },
            custGroupNameEdit(){
                return this.$store.getters.hasPermission("CUST_GROUP_EDIT");
            },custGroupDelete(){
                return this.$store.getters.hasPermission("CUST_GROUP_DELETE");
            },
            custGroupInfromation(){
                return this.$store.getters.hasPermission("CUST_GROUP_INFORMATION");
            },

        }
    }

</script>

<style lang="scss">
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .dataListTable .cell{ white-space:nowrap; }
</style>



// WEBPACK FOOTER //
// src/views/CustomerManagement.vue